import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';
import { Button } from 'react-admin';

import Modal from '@src/custom/modal-window';
import Data from './attachment-selector-data';

const StyledDiv = styled('div')({
    textAlign: 'center',
});

const AttachmentSelector = (props) => {
    const { onAttachmentSelected, articleSuitable } = props;

    const [modalOpen, setModalOpen] = useState(false);

    const handleOpenButtonClick = useCallback(() => {
        setModalOpen(true);
    }, [setModalOpen]);

    const handleClose = useCallback(() => {
        setModalOpen(false);
    }, [setModalOpen]);

    const handleAttachmentSelected = useCallback((attachment) => {
        setModalOpen(false);
        onAttachmentSelected(attachment);
    }, [setModalOpen, onAttachmentSelected]);

    return (
        <StyledDiv>
            <Button
                label="Choose file from library"
                size="large"
                onClick={handleOpenButtonClick}
            />
            <Modal
                open={modalOpen}
                title="Choose file"
                onClose={handleClose}
            >
                <Data
                    articleSuitable={articleSuitable}
                    onAttachmentSelected={handleAttachmentSelected}
                />
            </Modal>
        </StyledDiv>
    );
};

AttachmentSelector.propTypes = {
    onAttachmentSelected: PropTypes.func.isRequired,
};

export default AttachmentSelector;
